import React from 'react'

export default function TabHeader(props) {
  return (
    <div className={'bj-data-tab-header d-flex ' + props.className}>
      {
        props.tabs.map((it, idx) => {
          if (it != null) {
            return (
              <div key={idx} className={'d-center fs-16 sm-fs-14 f-m cursor-point ' + (idx === props.selected ? 'tab-active' : 'tab-normal')} onClick={() => {props.onChange(idx)}}>
                {it}
              </div>
            )
          }
        })
      }
    </div>
  )
}

